import React from "react";
import { Hooks, UseExpandedInstanceProps, UseExpandedRowProps, Row } from "react-table";
import { useTranslation } from "react-i18next";
import COLORS from "constants/Colors";
import ButtonBase from "components/ButtonBase";
import { SvgIcon } from "components/Icon";
import { IcArrowBack } from "components/SvgIcons";

const useSelection = <T extends object>(hooks: Hooks<T>) => {
  hooks.visibleColumns.push((newColumns) => [
    ...newColumns,
    {
      id: "expand",
      sticky: "right",
      width: 60,
      // eslint-disable-next-line react/display-name
      Header: ({ toggleAllRowsExpanded }: UseExpandedInstanceProps<T>) => {
        const { t } = useTranslation();
        return (
          <ButtonBase
            onClick={() => {
              toggleAllRowsExpanded(false);
            }}
            className="d-block m-auto"
            style={{ color: COLORS.Primary, fontWeight: "bold" }}
          >
            {t("Close all")}
          </ButtonBase>
        );
      },
      // eslint-disable-next-line react/display-name
      Cell: ({ row }: { row: UseExpandedRowProps<Row> }) => (
        <div className={`circle ${row.isExpanded ? "active" : ""}`} {...row.getToggleRowExpandedProps()}>
          <SvgIcon component={IcArrowBack} fontSize="small" className="m-0" />
        </div>
      ),
    },
  ]);
};

export default useSelection;
